import {useEventBus} from '@vueuse/core'
import {isEqual} from 'lodash'
import {useNuxtApp} from "nuxt/app"
import {defineStore} from 'pinia'
import {useNotification} from "@/composables/useNotification"
import {$larafetch} from "@/utils/$larafetch"

export const useStatic = defineStore('static', {

    state: () => ({
        carrierTypes: [],
        carrierLegalForms: [],
        countries: [],
        years: [],
        activeYear: null
    }),

    actions: {
        getStaticData() {
            const oldStaticData = {
                carrierTypes: this.carrierTypes,
                carrierLegalForms: this.carrierLegalForms,
                countries: this.countries,
                years: this.years,
                activeYear: this.activeYear
            }

            $larafetch(useNuxtApp().$apiRoute('spa.basedata.statics.index'), {
                method: 'GET'
            }).then(response => {
                this.carrierTypes = response.carrierTypes
                this.carrierLegalForms = response.carrierLegalForms
                this.countries = response.countries
                this.years = response.years
                // find the active year in the years array
                if (!this.activeYear) this.activeYear = response.years.reduce((acc, year) => {
                    return year.is_active ? year : acc
                }, null)

                if (!isEqual(oldStaticData, {
                    carrierTypes: this.carrierTypes,
                    carrierLegalForms: this.carrierLegalForms,
                    countries: this.countries,
                    years: this.years,
                    activeYear: this.activeYear
                })) {
                    useEventBus('staticData').emit()
                }

            }).catch(error => {
                const notification = useNotification()
                const app = useNuxtApp()
                if (error && error.response && error.response.status === 422) {
                    notification.error(app.$i18n.t('invalidRequestData'))
                } else if (error && error.response && error.response.status === 404) {
                    notification.error(app.$i18n.t('modelDoesNotExist'))
                } else {
                    if (error && error.response?._data.message) {
                        notification.error(app.$i18n.t('generalRequestError') + '\n' + error.response._data.message)
                    } else if ( error && error.response?._data) {
                        notification.error(app.$i18n.t('generalRequestError') + '\n' + error.response._data)
                    } else {
                        notification.error(app.$i18n.t('generalRequestError'))
                    }
                }
            })
        }
    }
})